import createStore from 'unistore';
import $ from 'jquery';

import { fetchJSON } from './utils';

export const Store = createStore({
  isBeforeElection: false,
  data: false,
  dataIndex: 0,
  dataRegio: false,
  regioId: ARTICLE_CONFIG.regioId || 'de',
  brexit: false,
  isDragging: false
});

export const Actions = {
  async loadData(state) {
    const data = await fetchJSON('data/data.json');
    return {
      data,
      dataIndex: state.isBeforeElection ? 0 : data.length - 1
    };
  },

  async loadRegioData() {
    const dataRegio = await fetchJSON('data/regional_hist.json');
    return { dataRegio };
  },

  setRegioId(state, regioId) {
    return { regioId };
  },

  setDataIndex(state, dataIndex) {
    return { dataIndex }
  },

  setBrexit(state, brexit) {
    return { brexit };
  },

  setDragging(state, isDragging) {
    if (isDragging) {
      document.body.ontouchmove = (e) => { e.preventDefault; return false; };
    } else {
      document.body.ontouchmove = (e) => { return true; };
    }

    return { isDragging };
  }
};

$('html').toggleClass('is-before-election', Store.getState().isBeforeElection);
$('html').toggleClass('is-post-election', !Store.getState().isBeforeElection);
